import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './messages.magic.css.js';
import script from './messages.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',{staticClass:"messages",attrs:{"part":"messages"}},[_c('magic-ui-loader')],1):(!_vm.messageId && (!_vm.filteredMessages || !_vm.filteredMessages.length))?_c('div',{staticClass:"messages",attrs:{"part":"messages"}},[_c('div',{staticClass:"message",attrs:{"part":"message"}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"badge":"","name":"email","part":"icon"}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h2","part":"title","content":_vm.$t('messages.no-messages.title')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"description",attrs:{"part":"description","content":_vm.$t('messages.no-messages.text')}}),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[_c('magic-ui-link',{staticClass:"button",attrs:{"button":"","wide":"","variant":"primary","part":"button","to":_vm.RoutablePage.HOME},domProps:{"innerHTML":_vm._s(_vm.$t('messages.no-messages.button'))}})],1)],1)]):(_vm.messageId)?_c('div',{staticClass:"messages",attrs:{"part":"messages"}},[_c('magic-message',{staticClass:"message",attrs:{"part":"message"},domProps:{"message":_vm.message}})],1):_c('div',{staticClass:"messages",attrs:{"part":"messages"}},_vm._l((_vm.filteredMessages),function(message){return _c('magic-message',{key:message.id,staticClass:"message",attrs:{"summary":"","part":"message"},domProps:{"message":message}})}),1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-91e50390_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-91e50390";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
